var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Wrapper',[_c('Header',{staticStyle:{"width":"70%"},attrs:{"title":"Atualizar Multa","showButton":false}}),_c('Main',[_c('Container',[_c('Content',[_c('FineUpdated')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }